import type { RouteRecordRaw } from 'vue-router'

export const pipelinesRoutes: RouteRecordRaw[] = [
  {
    path: '/pipelines',
    name: 'pipelines',
    component: () => import('@/views/pipelines/PipelinesView.vue'),
    meta: { requiresAuth: true, title: 'Pipelines' },
  },
  {
    path: '/pipelines/settings',
    name: 'pipeline-settings',
    component: () => import('@/views/pipelines/PipelineSettingsView.vue'),
    meta: { requiresAuth: true, title: 'Pipeline Settings' },
  },
  {
    path: '/pipelines/reports',
    name: 'pipeline-reports',
    component: () => import('@/views/pipelines/PipelineReportsView.vue'),
    meta: { requiresAuth: true, title: 'Pipeline Reports' },
  },
]
